import { Dispatcher } from '../Dispatcher'
import { ActionType, ActionData } from '../actions/ActionTypes'
import { ActionCreator } from '../actions/ActionCreator'

import * as $ from 'jquery';

var API_URL: string = '/mock/api/';
var TIMEOUT: number = 10000;

var _pendingRequests: Object = {};

export class WebApiUtils {

    public static toggleSendResponses(merchantId: string, terminalId: string, value: boolean) {
        var url: string = this.makeUrl("helper");
        var key: ActionType = ActionType.TOGGLE_RESPONSES_DATA;

        this.abortPendingRequests(key);
        var params = { merchantId: merchantId, terminalId: terminalId, data: value };
        _pendingRequests[key] = this.post(url, params, this.onSuccess(key, params), this.onFailure(key, params));
    }

    public static getCommunicationData(merchantId: string, terminalId: string, onComplete: any = null, abortPending: boolean = true): void {
        var url: string = this.makeUrl("communication");
        var key: ActionType = ActionType.GET_COMMUNICATION_DATA;
        if (abortPending) {
            this.abortPendingRequests(key);
        }

        var params = { merchantId: merchantId, terminalId: terminalId };
        _pendingRequests[key] = this.get(url, params,
            this.onSuccess(key, params), this.onFailure(key, params), onComplete);
    }

    public static stopPeriodicCommunicationDataRequest: Object = {};

    public static getCommunicationDataPeriodically(merchantId: string, terminalId: string) {
        WebApiUtils.getCommunicationData(merchantId, terminalId, function () {
            if (WebApiUtils.shouldStopPeriodicCommunication(merchantId, terminalId)) {
                WebApiUtils.stopPeriodicCommunicationDataRequest[merchantId][terminalId] = false;
            } else {
                setTimeout(WebApiUtils.getCommunicationDataPeriodically.bind(WebApiUtils, merchantId, terminalId), 1000 * 15 * 1);
            }
        }, false);
    }

    private static shouldStopPeriodicCommunication(merchantId: string, terminalId: string): boolean {
        if (WebApiUtils.stopPeriodicCommunicationDataRequest.hasOwnProperty(merchantId)
            && WebApiUtils.stopPeriodicCommunicationDataRequest[merchantId].hasOwnProperty(terminalId)) {
            return WebApiUtils.stopPeriodicCommunicationDataRequest[merchantId][terminalId];
        }

        return false;
    }

    public static getConfigurationData(merchantId: string, terminalId: string): void {
        WebApiUtils.commonRequest('configuration', ActionType.GET_CONFIGURATION_DATA, merchantId, terminalId);
    }

    public static createFolders(merchantId: string, terminalId: string): void {
        WebApiUtils.commonRequest('createFolders', ActionType.REST_CREATE_FOLDERS, merchantId, terminalId);
    }

    private static commonRequest(urlPart: string, key: ActionType, merchantId: string, terminalId: string) {
        var url: string = this.makeUrl(urlPart);
        this.abortPendingRequests(key);

        var params = { merchantId: merchantId, terminalId: terminalId };
        _pendingRequests[key] = this.get(url, params,
            this.onSuccess(key, params), this.onFailure(key, params));
    }

    public static saveConfiguration(data: ActionData.ConfigurationData) {
        var url: string = this.makeUrl('configuration');
        var key: ActionType = ActionType.REST_SAVE_CONFIGURATION;
        this.abortPendingRequests(key);

        var params = { merchantId: data.merchantId, terminalId: data.terminalId, data: data.configuration };
        _pendingRequests[key] = this.post(url, params, this.onSuccess(key, params), this.onFailure(key, params));
    }

    public static deleteConfiguration(data: ActionData.ConfigurationData) {
        var url: string = this.makeUrl('configuration');
        var key: ActionType = ActionType.REST_DELETE_CONFIGURATION;
        this.abortPendingRequests(key);

        var params = { merchantId: data.merchantId, terminalId: data.terminalId, data: data.configuration };
        _pendingRequests[key] = this.delete(url, params, this.onSuccess(key, params), this.onFailure(key, params));
    }

    public static downloadConfigurationFiles(data: ActionData.ConfigurationFilesDownload) {
        var url: string = `${this.makeUrl('configurationfiles')}?merchantId=${data.merchantId}&terminalId=${data.terminalId}`;
        window.location.assign(url);
    }

    public static uploadConfigurationFiles(data: ActionData.ConfigurationFilesUpload) {
        var url: string = `${this.makeUrl('configurationfiles')}?merchantId=${data.merchantId}&terminalId=${data.terminalId}`;
        var key: ActionType = ActionType.REST_UPLOAD_CONFIGURATION_FILES;

        var formData = new FormData();
        formData.append('file', data.file)

        fetch(url, {
            method: 'POST',
            body: formData
        }).then(response => {
            if (response.status >= 200 && response.status < 300) {
                ActionCreator.webApiResponse(key, data, formData);
            } else {
                this.onFailure(key, formData)(response, response.statusText, response.statusText);
            }
        }).catch(error => {
            this.onFailure(key, formData)(error, "", error);
        });
    }

    private static delete(url: string, params: any, onSuccess: any, onFailure: any, onComplete: any = null) {
        return WebApiUtils.request('DELETE', url, params, onSuccess, onFailure, onComplete);
    }

    private static post(url: string, params: any, onSuccess: any, onFailure: any, onComplete: any = null) {
        return WebApiUtils.request('POST', url, params, onSuccess, onFailure, onComplete);
    }

    private static get(url: string, params: any, onSuccess: any, onFailure: any, onComplete: any = null) {
        return WebApiUtils.request('GET', url, params, onSuccess, onFailure, onComplete);
    }

    private static request(type: string, url: string, params: any, onSuccess: any, onFailure: any, onComplete: any = null) {
        var req = $.ajax({
            type: type,
            dataType: 'json',
            data: params,
            url: url,
            timeout: TIMEOUT
        })
            .done(onSuccess)
            .fail(onFailure);

        if (onComplete) {
            req.always(onComplete);
        }

        return req;
    }

    private static onSuccess(key: ActionType, params: Object) {
        return function (data: any, textStatus: any) {
            ActionCreator.webApiResponse(key, data, params);
        }
    }

    private static onFailure(key: ActionType, params: Object) {
        return function (response: any, textStatus: any, errorThrown: any) {
            if (response && response.statusText === "timeout") {
                ActionCreator.webApiResponse(ActionType.TIMEOUT, { originalActionType: key }, params);
            } else if (response.status) {
                ActionCreator.webApiResponse(ActionType.WEBAPI_ERROR, { originalActionType: key, text: errorThrown }, params);
            }
        }
    }

    private static makeUrl(part: string) {
        return API_URL + part;
    }

    private static abortPendingRequests(key: any) {
        if (_pendingRequests[key]) {
            _pendingRequests[key]._callback = function () { };
            _pendingRequests[key].abort();
            _pendingRequests[key] = null;
        }
    }
}


// WEBPACK FOOTER //
// ./Scripts/utils/WebApiUtils.ts